import { App, Space, Tag } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { clienteSetActive, clienteStartDelete } from "../../../actions/cliente";
import { ShowDeleteConfirm } from "../../../helpers";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { CheckCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { TableSearchBasicUi } from "../../ui/TableSearchBasicUi";
import { ContactoPersonaColumn, NroDocumentoColumn } from "../../ui";

const columns = (acciones) => [
  {
    title: "N°",
    dataIndex: "index",
    key: "index",
    render: (text, record, index) => <>{index + 1}</>,
  },
  {
    title: "Nombre",
    dataIndex: ["persona", "nombrecompleto"],
    key: "nombrecompleto",
    filteredValue: [acciones?.filteredColumn],
    onFilter: (value, record) =>
      String(record?.persona?.nombrecompleto)
        .toLowerCase()
        .includes(value.toLowerCase()) ||
      String(record?.persona.nrodocumento)
        .toLowerCase()
        .includes(value.toLowerCase()),
  },
  {
    title: "N° Documento",
    dataIndex: ["persona", "tipodocumento_nombre"],
    key: "tipodocumento_nombre",
    align: "center",
    render: (text, record) => (
      <NroDocumentoColumn
        nrodocumento={record?.persona?.nrodocumento}
        tipodocumento_nombre={record?.persona?.tipodocumento_nombre}
      />
    ),
  },
  {
    title: "Contacto",
    dataIndex: ["persona", "email"],
    key: "email",
    align: "center",
    render: (text, record) => (
      <ContactoPersonaColumn
        telefono={record?.persona?.telefono}
        email={record?.persona?.email}
        website={record?.persona?.website}
      />
    ),
  },
  {
    title: "Dirección",
    dataIndex: ["persona", "direccion"],
    key: "direccion",
  },
  {
    title: "Estado",
    dataIndex: "state",
    key: "state",
    align: "center",
    render: (text, record) =>
      text === true ? (
        <Tag icon={<CheckCircleOutlined />} color="green">
          Activo
        </Tag>
      ) : (
        <Tag icon={<MinusCircleOutlined />} color="red">
          Inactivo
        </Tag>
      ),
  },
  {
    title: "Acciones",
    dataIndex: "acciones",
    key: "acciones",
    render: (text, record) => (
      <Space size="middle">
        <ButtonUi
          typeUi={TipoButtonConstants.EditarTable}
          displayText={false}
          onClick={() => acciones.handleEditar(record)}
        />
        <ButtonUi
          typeUi={TipoButtonConstants.EliminarTable}
          displayText={false}
          onClick={() => acciones.handleEliminar(record)}
        />
      </Space>
    ),
  },
];
export const ClienteTable = ({ data, loading, handleOpenForm }) => {
  const { modal } = App.useApp();

  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const handleEditar = (data) => {
    dispatch(clienteSetActive(data));
    handleOpenForm();
  };
  const handleEliminar = (item) => {
    const { nombrecompleto } = item?.persona;
    ShowDeleteConfirm({
      modal,
      title: "¿Está seguro de eliminar el cliente seleccionado?",
      content: nombrecompleto,
      callback: (isConfirmed) => {
        if (isConfirmed) {
          dispatch(clienteStartDelete(item));
        }
      },
    });
  };
  const onSearch = (value) => {
    setSearchText(value);
  };
  return (
    <TableSearchBasicUi
      columns={columns({
        filteredColumn: searchText,
        handleEditar,
        handleEliminar,
      })}
      rowKey="id"
      bordered
      data={data}
      onSearch={onSearch}
      loading={loading}
      size="small"
    />
  );
};
